<template>
    <div style="width: 100%;">
        <van-nav-bar :fixed="true" left-arrow left-text="返回" @click-left="onClickLeftBack">
            <template #title>
                <van-search v-model="name" shape="round" background="#00000000" placeholder="请输入姓名"
                    @input="onSearchName" />
            </template>
            <template #right>
                <van-icon name="wap-nav" size="18" @click="onSelect" />
            </template>
        </van-nav-bar>
        <div style="width: 100%;height:50px;"></div>
        <div
            style="width: 100%;display: flex;flex-direction: column; justify-content: center;align-items: center;padding-top: 20px;">
            <my-text-one :title="teamName + columns[selectIndex] + '成员信息'"
                :textContent="teamName + columns[selectIndex] + '成员信息'"></my-text-one>
            <div style="height: 20px;"></div>

            <div class="list-view" :style="{ height: screenHeight }">
                <el-row :gutter="10">
                    <el-col :span="12" v-for="(item, i) in memberList" :key="i" @click="currentIndex = i">

                        <el-card :body-style="{ padding: '0px' }">
                            <div
                                style="width: 100%;height: 315px;display: flex;flex-direction: column;align-items: center;">
                                <img :src="item.img" alt="" style="width: 100%;height: 222px;" @click="imagePreview(i)">
                                <div style="width: 100%;display: flex;flex-direction: column;margin-top: 10px;"
                                    @click="goMemberContent(i)">
                                    <label
                                        style="font-size: 10.5pt;color: white;margin-left: 8px;margin-bottom: 5px;">姓名：{{
                                            item.name }}</label>
                                    <label
                                        style="font-size: 10.5pt;color: white;margin-left: 8px;margin-bottom: 5px;">电话号码：{{
                                            item.phone }}</label>
                                    <label
                                        style="font-size: 10.5pt;color: white;margin-left: 8px;margin-bottom: 5px;">加入时间：{{
                                            item.createTime }}</label>
                                </div>

                            </div>
                        </el-card>
                    </el-col>

                </el-row>
            </div>
            <!-- <el-tabs type="border-card">
                <el-tab-pane label="配置管理">
                    <div style="height: 700px;background-color: white;"></div>
                </el-tab-pane>
                <el-tab-pane label="角色管理">角色管理</el-tab-pane>
                <el-tab-pane label="定时任务补偿">定时任务补偿</el-tab-pane>
            </el-tabs> -->
        </div>
        <div class="kuang">
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
        </div>
        <div @touchstart="touchStart()" @touchend="touchEnd()">
            <van-image-preview :closeable="true" v-model="showPreviewImg" :images="previewImages">
            </van-image-preview>

        </div>
        <van-share-sheet v-model="showShare" title="图片操作" :options="shareOptions" @select="onSelectShare" />

        <!-- <template v-slot:index>第{{ index }}页</template> -->
        <van-popup v-model="showPopup" :round="true" position="bottom" :style="{ height: '35%' }"
            style="background-color: #ffffff;">
            <van-picker title="选择" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel"
                @change="onChange" style="background-color: #fff;" />
        </van-popup>
            
    </div>
    </div>

</template>

<script>
import LivePlayer from '@liveqing/liveplayer'
import MyTextOne from "@/components/MyTextOneMobile.vue";
import { ImagePreview } from 'vant'
import { Dialog } from 'vant';
import { Toast } from 'vant';

export default {
    name: 'MemberList',
    components: {
        LivePlayer,
        MyTextOne,
    },
    data() {
        return {
            pageIndex: 1,
            pageSize: 40,
            // 屏幕宽度
            screenWidth: window.screen.width,
            // 屏幕高度
            screenHeight: (window.screen.height - 240) + "px",
            // 分屏布局
            playerNum: 20,

            memberList: [
                { title: '视频1', music: '' },
            ],
            dataForm: {
                key: ''
            },

            dataListLoading: false,
            addOrUpdateVisible: false,
            activeName: '1',
            selectTabName: 1,
            showPreviewImg: false,
            previewImages: [],
            showPopup: false,
            columns: ['全部', '队员', '学生'],
            selectIndex: 0,
            name: '',
            showShare: false,
            shareOptions: [
                // { name: '微信', icon: 'wechat' },
                // { name: '微博', icon: 'weibo' },
                { id:1, name: '保存图片', icon: require('@/assets/img/baocuntupian.png') },
            ],
        };
    },
    computed: {
      teamName () {
        return (this.$store && this.$store.state.brand && this.$store.state.brand.teamName) || '音愈童心'
      }
    },
    methods: {
        // 获取数据列表
        getDataList(index) {
            this.dataListLoading = true
            console.log(this.columns[index])
            this.$http({
                url: this.$http.adornUrl('/app/member/list'),
                method: 'get',
                params: this.$http.adornParams({
                    'page': this.pageIndex,
                    'limit': this.pageSize,
                    'type': this.columns[index] === '全部' ? '' : this.columns[index],
                    'name': this.name
                })
            }).then(({ data }) => {
                if (data && data.code === 0) {
                    this.memberList = data.page.list
                    this.playerNum = data.page.totalCount
                    console.log(this.memberList);

                } else {
                    this.memberList = []
                    this.totalPage = 0
                }
                this.dataListLoading = false
            })
        },
        longPressHandler() {
            console.log("长按")
        },
        touchEnd() {
            //手指离开
            clearTimeout(this.timer);
        },
        touchStart() {
            //手指触摸
            clearTimeout(this.timer); //再次清空定时器，防止重复注册定时器
            this.timer = setTimeout(() => {
                // let time = '成绩单_' + parseInt(new Date().getTime() / 1000)
                // console.log("长按");
                // this.downloadIamge(this.previewImages[0], time);
                // this.downLoad()
                this.showShare = true
                // this.isImgDownLoad = true
            }, 500);

        },
        onSelectShare(option){
            console.log(option.id);
            if (option.id===1) {
                this.downLoadImg()
            }
            this.showShare = false
        },
        downLoadImg() {

            console.log("长按");
            if (!window.plus) {
                return
            }
            var timestamp = (new Date()).valueOf();
            var downLoader = plus.downloader.createDownload(this.previewImages[0], {

                method: 'GET',

                filename: '_downloads/image/diyun_' + timestamp + '.jpg'
            }, function (download, status) {
                console.log(status)

                if (status == 200) {
                    var fileName = download.filename;

                    /**
                     * 保存至本地相册
                     */
                    console.log(fileName)
                    plus.gallery.save(fileName, function () {
                        Toast.success('图片保存成功');

                    }, function () {
                        Toast.fail('保存失败，请重试！');
                    });
                } else {
                    Toast.fail('保存失败，请重试！');
                }
            });
            downLoader.start();


        },
        imagePreview(i) {
            this.previewImages = [this.memberList[i].img]
            this.showPreviewImg = true
            // ImagePreview({
            //     images: [
            //         this.memberList[i].img,
            //     ],
            //     closeable: true,
            // });

        },
        onSelect() {
            this.showPopup = true
        },
        onConfirm(value, index) {
            console.log(this.columns[index])
            this.selectIndex = index
            this.getDataList(index)
            this.showPopup = false
        },
        onChange(picker, value, index) {
        },
        onCancel() {
            this.showPopup = false

        },
        onSearchName() {
            this.getDataList(this.selectIndex)
        },
        goMemberContent(index) {
            console.log(index);
            let data = this.memberList[index]
            console.log(data);
            this.$router.push({
                name: "MemberContent",
                params: {
                    data: data
                }
            })

        },
        onClickLeftBack() {
            this.$router.back()
        },
        handleClick(tab, event) {
            this.selectTabName = Number(tab.name)
            console.log(this.selectTabName, this.memberList[0].type);
        },

    },
    mounted() {
        this.getDataList(0)

    },
    created() {
    }
}
</script>
<style lang="less" scoped>
// .van-search{
//     background-color: #00000000;
// }
.van-nav-bar {
    background-color: #00000000;
}

/* 需要滚动条隐藏的列表 */
.list-view {
    width: 95%;
    // height: 630px;
    margin-top: 10px;
    overflow-x: hidden;
    overflow-y: auto;
    // background-color: yellow;
}

/* 隐藏滚动条 */
.list-view::-webkit-scrollbar {
    display: none;
}

/deep/ .el-tabs__nav {
    // width: 10px;
    //   font-size: 29px;
    // line-height: 55px;
    height: 35px;
}


::v-deep .el-tabs__item.is-active {
    color: skyblue; //选中
    opacity: 1;
}

::v-deep .el-tabs__item:hover {
    color: skyblue; //悬浮
    cursor: pointer;
    opacity: 1;
}

/deep/.el-tabs__item {
    /* 修改为您想要的文字大小 */
    font-size: 10pt !important;
    color: #fff;
    font-weight: bold;
}

/deep/.el-tabs__nav-wrap::after {
    /* 去掉下划线 */
    position: static !important;
}

/* 下划线颜色 */
::v-deep .el-tabs__active-bar {
    background-color: skyblue;
}

.el-card {
    background-color: rgba(255, 255, 255, 0.4) !important;

    box-shadow: 0 5px 15px rgba(20, 20, 20, 0.6) !important;

    backdrop-filter: blur(50px) !important;
    border: none !important;
    border-radius: 5px !important;
}

.el-row {
    margin-bottom: 20px;
}

.el-row:last-child {
    margin-bottom: 0;
}

.el-col {
    border-radius: 4px;
    margin-bottom: 20px
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

/**背景 **/

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.kuang {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -10;
    background-image: linear-gradient(180deg, rgb(0, 6, 31), rgb(0, 2, 20));

}

.bubble {
    position: absolute;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: inset 0 0 8px #fff;
    animation: flutter 10s infinite;
    opacity: 0;
}

@keyframes flutter {
    0% {
        transform: translateX(0);
        bottom: -100px;
        opacity: 1;
    }

    50% {
        transform: translateX(100px);
        opacity: 0.5;
    }


    100% {
        transform: translateX(0px);
        bottom: 100%;
        opacity: 0;

    }
}

.bubble:nth-child(1) {
    left: -10%;
    width: 50px;
    height: 50px;
    animation-duration: 9s;
    animation-delay: 0.1s;
}

.bubble:nth-child(2) {
    left: 15%;
    width: 20px;
    height: 20px;
    animation-duration: 6s;
    animation-delay: 1.5s;

}

.bubble:nth-child(3) {
    left: 20%;
    width: 60px;
    height: 60px;
    animation-duration: 10s;



}

.bubble:nth-child(4) {
    left: 30%;
    width: 30px;
    height: 30px;
    animation-duration: 5.5s;
    animation-delay: 1.5s;

}

.bubble:nth-child(5) {
    left: 40%x;
    width: 50px;
    height: 50px;
    animation-duration: 12s;



}

.bubble:nth-child(6) {
    left: 50%;
    width: 20px;
    height: 20px;
    animation-duration: 6s;
    animation-delay: 1s;

}

.bubble:nth-child(7) {
    left: 60%;
    width: 40px;
    height: 40px;
    animation-duration: 8s;
    animation-delay: 1s;

}

.bubble:nth-child(8) {
    left: 65%;
    width: 60px;
    height: 60px;
    animation-duration: 15s;

}

.bubble:nth-child(9) {
    left: 80%;
    width: 55px;
    height: 55px;
    animation-duration: 9s;
    animation-delay: 0.5s;

}

.bubble:nth-child(10) {
    left: 100%;
    width: 40px;
    height: 40px;
    animation-duration: 12s;

}

/** 发光字体 */
.nav {
    position: relative;
    font: 10 12pt '';
    color: #ffffff;
    cursor: pointer;
    font-weight: bold;
}

.nav:hover span {
    color: #FFFFFF;
    text-shadow: 0 0 10px #FFFFFF,
        0 0 20px #FFFFFF,
        0 0 30px #FFFFFF,
        0 0 50px #FFFFFF,
        0 0 70px #FFFFFF,
        0 0 90px #FFFFFF;

}
</style>
